import { css as objectToCss } from '../object/to/css';
import { injectStyle } from './injectStyle';

/**
 * Permite inserta una regla CSS
 *
 * @param {string} selector - el nombre/selector de la regla (ej: "#mi-id")
 * @param {object} rules - el objeto {key: value} que corresponde a la lista de propiedades css
 * @return {HTMLElement} el element insertado
 *
 * @example
 * injectRule('#miId', {
 *   display: none,
 *   backgroundColor: '#ff4455',
 * });
 */

const PREFIX = 'injected_rule_';

export function injectRule(selector, rules, { insertBefore = false, overwrite = true } = {}) {
  if (typeof selector !== 'string' || typeof rules !== 'object') {
    throw 'parametros incorrectos';
  }
  const css = objectToCss(rules);
  return injectStyle(`${selector}{${css}}`, PREFIX + name, { insertBefore, overwrite });
}
